import { ChangeRrcLimitFormField } from "../types/change-rrc-limit.types";

export const changeRrcLimitFormFields: Array<ChangeRrcLimitFormField> = [
  {
    label: 'Минимальный лимит',
    fieldName: 'minLimit'
  },
  {
    label: 'Максимальный лимит',
    fieldName: 'maxLimit'
  }
]
